<template>
  <v-speed-dial
    v-if="exibirBotao"
    v-model="fab"
    direction="left"
    open-on-hover
    transition="slide-y-reverse-transition"
    id="icon-arrastavel-btn-chat-suporte"
  >
    <template v-slot:activator>
      <v-btn v-model="fab" color="rgb(216, 14, 43)" dark fab @click="controleDeExibicaoChat">
        <v-icon>mdi-forum</v-icon>
      </v-btn>
    </template>

    <v-btn
      v-if="OCULTAR_BOTAO_DE_OCULTAR_NA_TELA_DE_LOGIN"
      fab
      dark
      color="rgb(216, 14, 43)"
      @click="ocultarChatOctadesk"
    >
      <v-icon>mdi-eye-off-outline</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>
export default {
  name: "ChatSuporteOctadeskLogado",
  data() {
    return {
      exibirBotao: true,
      fab: false
    };
  },
  computed: {
    OCULTAR_BOTAO_DE_OCULTAR_NA_TELA_DE_LOGIN() {
      return this.$route.name !== 'Home';
    }
  },
  mounted() {    
    this.sincronizarVisibilidadeChat();
    window.addEventListener("chat-suporte-visibilidade-change", this.sincronizarVisibilidadeChat);
    this.ocultarChatIFrame();
  },
  beforeDestroy() {
    window.removeEventListener("chat-suporte-visibilidade-change", this.sincronizarVisibilidadeChat);
  },
  watch: {
    OCULTAR_BOTAO_DE_OCULTAR_NA_TELA_DE_LOGIN(valor) {
      window.octadesk.chat.login({
        name: localStorage.getItem("nome") ? localStorage.getItem("nome") : null,
        email: localStorage.getItem("email") ? localStorage.getItem("email") : null
      });
      window.dispatchEvent(new Event("chat-suporte-visibilidade-change"));
    }
  },
  methods: {
    controleDeExibicaoChat() {
      window.octadesk.chat.toggle();
    },
    sincronizarVisibilidadeChat() {
      if (!this.OCULTAR_BOTAO_DE_OCULTAR_NA_TELA_DE_LOGIN) {
        this.exibirChatOctadesk();
        return;
      }

      const valor = localStorage.getItem("chat_suporte_visivel");

      if (valor === 'N') {
        this.ocultarChatOctadesk();
        return;
      }

      this.exibirChatOctadesk();
    },

    ocultarChatIFrame() {
      const iframe = document.getElementById("octadesk-octachat-appchat");
      if (iframe) {
        iframe.style.display = 'none';
      } else {
        setTimeout(this.ocultarChatIFrame, 500);
      }
    },

    ocultarChatOctadesk() {
      localStorage.setItem("chat_suporte_visivel", "N");
      this.exibirBotao = false;

      if (window.octadesk && window.octadesk.chat) {
        window.octadesk.chat.closeConversation();
        window.octadesk.chat.hideApp();
      }

      this.ocultarChatIFrame();
    },

    exibirChatOctadesk() {
      this.exibirBotao = true;
    },
  },
};
</script>

<style>
#icon-arrastavel-btn-chat-suporte {
  position: fixed;
  z-index: 9999999999 !important;
  right: 30px;
  bottom: 45px;
  cursor: pointer;
}

body.octadesk-hidden.octadesk-app {
  z-index: auto !important;
  pointer-events: auto !important;
  position: static !important;
}

body.octadesk-hidden iframe[src*="octadesk"],
body.octadesk-hidden [id*="octadesk"],
body.octadesk-hidden [class*="octadesk"] {
  display: none !important;
  pointer-events: none !important;
}
</style>